interface CleanupInterface {
    (input: any): string
}

const removeMask: CleanupInterface = (input) => {
    return input.replace(/\D/g, '')
}

export default removeMask
